export const pollUntilResponse = async <T>(
  apiCall: () => Promise<T>,
  options: {
    interval?: number; // milliseconds between calls
    maxAttempts?: number; // maximum number of attempts
    shouldContinue?: (response: T) => boolean; // custom condition to continue polling
  } = {}
): Promise<T> => {
  const { interval = 5000, maxAttempts = 60, shouldContinue = () => false } = options;

  let attempts = 0;

  while (attempts < maxAttempts) {
    attempts++;

    const response = await apiCall();

    if (!shouldContinue(response)) {
      return response;
    }

    if (attempts < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }

  throw new Error(`Polling failed after ${maxAttempts} attempts`);
};
